import Player from "./GameObjects/Player";
import Game from "./GameObjects/Game";
import Portal from "./GameObjects/Portal";
import LevelOne from "./GameObjects/Maps/LevelOne";
import Score from "./GameObjects/Score";
import Fauci from "./GameObjects/Fauci";
import LevelTwo from "./GameObjects/Maps/LevelTwo";
import LevelThree from "./GameObjects/Maps/LevelThree";

let player = new Player;
let portal = new Portal('MainPortal');
let score = new Score;
let fauci = new Fauci;
let game = new Game(player, portal, score, document.getElementById('Game'), fauci);

let lvl1 = new LevelOne;
let lvl2 = new LevelTwo;
let lvl3 = new LevelThree;
game.addLevel(lvl1);
game.addLevel(lvl2);
game.addLevel(lvl3);
game.render();
game.load();
